import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export default function MarqueeStrip() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const messages = [
    "AUTOMATIZACIÓN REAL",
    "IA PARA PYMES",
    "MÁS REVENUE",
    "MENOS COSTES",
    "CERO FRICCIONES",
    "TODOS LOS SECTORES",
    "TECNOLOGÍA DE PRIMERA",
    "EL FUTURO ES AHORA",
    "EMINAL DYNAMICS",
  ];

  const allMessages = [...messages, ...messages];

  return (
    <motion.section
      data-testid="marquee-section"
      ref={ref}
      initial={{ opacity: 0 }}
      animate={isInView ? { opacity: 1 } : {}}
      transition={{ duration: 1 }}
      className="relative py-5 md:py-6 overflow-hidden"
    >
      {/* Light beams top/bottom */}
      <div className="light-beam absolute top-0 left-0 right-0" />
      <div className="light-beam absolute bottom-0 left-0 right-0" />

      <div className="flex whitespace-nowrap marquee-track">
        {allMessages.map((msg, i) => (
          <span
            key={i}
            className="inline-flex items-center mx-8 md:mx-12 text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-white/20"
          >
            <span className="w-1 h-1 rounded-full bg-[#00E5FF]/50 mr-6 shrink-0" />
            {msg}
          </span>
        ))}
      </div>
    </motion.section>
  );
}
